module.exports = "/_next/static/images/LetEngineersFocused-34bd3a7a9f5d26ee89ecd11a9d55f92a.webp";